import React from 'react';
import ProjectsInput from './ProjectsInput';
import { WEEKLY_APP_URL } from '../../../config';
import { buildWeeklyUrl, isValidWeeklySlug, parseWeeklyUrl } from '../../../utils/weeklyTab';

const labelClass = 'block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1';
const inputClass = 'w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white';

// Éditeur des propriétés spécifiques au type de l'onglet
const TabPropertiesEditor = ({ tab, onPropertyChange, onConvertToWeekly }) => {
  switch (tab.type) {
    case 'gallery':
      return (
        <div>
          <label className={labelClass}>IDs des projets</label>
          <ProjectsInput
            projects={tab.properties.projects}
            onChange={(projectIds) => onPropertyChange('projects', projectIds)}
          />
        </div>
      );
    case 'gi-ai':
      return (
        <div>
          <label className={labelClass}>Client ID</label>
          <input
            type="number"
            step="1"
            value={tab.properties.clientId ?? ''}
            onChange={(e) => {
              const raw = e.target.value;
              if (raw === '') {
                onPropertyChange('clientId', null);
                return;
              }
              const parsed = parseInt(raw, 10);
              onPropertyChange('clientId', isNaN(parsed) ? null : parsed);
            }}
            className={inputClass}
            placeholder="Ex: 1234"
          />
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Identifiant du client transmis au GI AI Report Viewer (clientId).
          </p>
        </div>
      );
    case 'weekly': {
      const clientSlug = tab.properties.clientSlug || '';
      const weeklyUrl = isValidWeeklySlug(clientSlug) ? buildWeeklyUrl(WEEKLY_APP_URL, clientSlug) : null;
      return (
        <div>
          <label htmlFor="weekly-client-slug" className={labelClass}>Slug du client Weekly</label>
          <input
            id="weekly-client-slug"
            type="text"
            value={clientSlug}
            onChange={(e) => {
              // L'URL complète du client peut être collée : seul son slug est gardé
              const raw = e.target.value.trim().toLowerCase();
              onPropertyChange('clientSlug', parseWeeklyUrl(raw)?.clientSlug ?? raw);
            }}
            className={inputClass}
            placeholder="Ex: samsung-ce"
          />
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            La partie de l'adresse Weekly qui suit /w/. L'URL complète du client peut aussi être collée.
          </p>
          {clientSlug && !weeklyUrl && (
            <p className="mt-1 text-xs text-red-600 dark:text-red-400">
              Slug invalide : uniquement des minuscules, chiffres et tirets. Pour une URL, seule celle de la page du client (…/w/slug) est acceptée.
            </p>
          )}
          {weeklyUrl && (
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              URL affichée :{' '}
              <a
                href={weeklyUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 dark:text-blue-400 hover:underline break-all"
              >
                {weeklyUrl}
              </a>
            </p>
          )}
        </div>
      );
    }
    case 'embed':
    case 'external': {
      // Une page client Weekly en contenu embarqué : le type Weekly l'affiche, jail compris
      const weeklySlug = tab.type === 'embed' ? parseWeeklyUrl(tab.properties.src)?.clientSlug : null;
      return (
        <div>
          <label className={labelClass}>
            URL {tab.type === 'embed' ? '(HTTPS uniquement)' : ''}
          </label>
          <input
            type="url"
            value={tab.properties.src || ''}
            onChange={(e) => onPropertyChange('src', e.target.value)}
            className={inputClass}
            placeholder={tab.type === 'embed' ? 'https://example.com/embed' : 'https://example.com'}
          />
          {weeklySlug && (
            <div className="mt-3 p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md">
              <p className="text-sm text-blue-700 dark:text-blue-300">
                Cette URL pointe vers Weekly. Le type Weekly ne demande que le slug du client et limite la navigation à ce client (jail).
              </p>
              <button
                type="button"
                onClick={() => onConvertToWeekly(weeklySlug)}
                className="mt-2 px-3 py-1 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                Convertir en onglet Weekly
              </button>
            </div>
          )}
        </div>
      );
    }
    default:
      return null;
  }
};

export default TabPropertiesEditor;
